import { useAppSelector } from '../../store.model';
import { getMyWorkspaceSelector } from '../../workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../theme/ui/Dashboard/Dashboard.model';
import useStructuresWorkspaces from './useStructuresWorkspaces';
import useStructuresWorkspace from './useStructuresWorkspace';
import { useMemo } from 'react';

interface IUseCommanderOfflineProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}
function useStructures(props: IUseCommanderOfflineProps) {
  const { typeRequest, workspaceId } = props;

  const structuresWorkspaces = useStructuresWorkspaces({
    skip: typeRequest !== 'workspaces',
  });
  const structureWorkspace = useStructuresWorkspace(workspaceId, {
    skip: typeRequest === 'workspaces',
  });

  const myWorkspace = useAppSelector(getMyWorkspaceSelector);
  const structureWorkspaceMappedData = useMemo(
    () => ({
      ...structureWorkspace,
      data: structureWorkspace.data ? [structureWorkspace.data] : undefined,
      originalArgs: [workspaceId ?? myWorkspace?.id],
    }),
    [myWorkspace?.id, structureWorkspace, workspaceId]
  );
  switch (typeRequest) {
    case 'workspaces':
      return structuresWorkspaces;
    default:
      return structureWorkspaceMappedData;
  }
}

export default useStructures;
